export const masterMessage = {
  botMessageList: "ボットメッセージ一覧",
  platformTypeSelect: "対象:",
  groupTypeSelect: "グループタイプ:",
  editMessage: "メッセージ編集",
  messageList: "メッセージ一覧",
};
